import React, { useEffect, useState } from "react";
import TabSearchHistoryApplicationPANListing from "./TabSearchHistoryApplicationPANListing";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { PANListResponse } from "src/models/PAN.model";
import { Tooltip } from "@mui/material";
import { formatDateAndTime } from "src/utils/dateAndTime";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useGetPanApplicationSearchByACKQuery, useGetPanApplicationSearchBySRNQuery } from "src/services/SearchHistoryService";
import { useChangePANStatusMutation, useGetPanApplicationFlowMutation } from "src/services/PANService";
import { useReuploadAcknowledgmentMutation } from "src/services/UserServices";
import { showToast } from "src/utils/toaster/showToast";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCopyToClipboard from "src/components/UI/atoms/ATMCopyToClipboard/ATMCopyToClipboard";
import { IoCopyOutline } from "react-icons/io5";
import { applicationStatus } from "src/utils/history/applicationStatus";
import { BsCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import HistoryDialog from "src/pages/history/list/Dialog/HistoryDialog";
import ReuploadAcknowledgementDialogWrapper from "src/components/ReuploadAcknowledgementDialog/ReuploadAcknowledgementDialogWrapper";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import AuthHOC from "src/userAccess/AuthHOC";
import { AccessAction } from "src/utils/Enums/AccessAction";

const TabSearchHistoryApplicationPANListingWrapper = () => { 
   //STATE
    const [isOpenReuploadDialog, setIsOpenReuploadDialog] = useState(false);
    const [isShowFlowDialog, setIsShowFlowDialog] = useState(false);
    const [setFlowData, setSetFolwData] = useState<any>([]);
    const [PanIdVerfiy, setPanIdVerfiy] = useState("");


  // Reupload is its own role action (USERS > REUPLOAD_PDF), the same one
  // /user/reupload-pdf is authorised against; SUPER_ADMIN always passes.
  const canReuploadAcknowledgement = Boolean(
    AuthHOC({
      resultType: "BOOLEAN",
      type: "ACTION",
      moduleName: "USERS",
      action: AccessAction.REUPLOAD_PDF,
    })
  );

      
  //USEHOOKS
  const { panSearchHistoryValue }: any = useSelector(
    (state: RootState) => state.searchHistory
  ); 

  const searchType = panSearchHistoryValue?.searchType;

const srn =
  panSearchHistoryValue?.searchType === 'SRN'
    ? panSearchHistoryValue?.srnNumber || ''
    : panSearchHistoryValue?.srnNumber || '';

  useEffect(()=>{
    console.log("panSearchHistoryValue", panSearchHistoryValue)
  }, [panSearchHistoryValue])
  const navigate = useNavigate();

  // MUTATION
  const [flowData, flowDataInfo] = useGetPanApplicationFlowMutation();
  const [changeStatus] = useChangePANStatusMutation();
 
  const [reuploadAcknowledgment] = useReuploadAcknowledgmentMutation();
  

  // const { data, isLoading, isFetching } = useGetPanApplicationSearchBySRNQuery( srn || "", { skip: !srn } );
  //APIS
    const {
      data: srnData,
      isLoading: srnLoading,
      isFetching: srnFetching,
      error: srnError,
    } = useGetPanApplicationSearchBySRNQuery(
      srn,
      {
      skip: searchType !== 'SRN' || !srn,
      }
    );

    const {
      data: ackData,
      isLoading: ackLoading,
      isFetching: ackFetching,
      error: ackError,
    } = useGetPanApplicationSearchByACKQuery(
      srn,
      {
       skip: searchType !== 'ACK' || !srn,
      }
    );

    // -------------------- FINAL MERGED STATE --------------------
    const data = searchType === 'SRN' ? srnData : ackData;
    const isLoading = srnLoading || ackLoading;
    const isFetching = srnFetching || ackFetching;
    const error = srnError || ackError;

    // -------------------- OPTIONAL ERROR LOG --------------------
    useEffect(() => {
      if (error) {
        console.error('Search API Error →', error);
      }
    }, [error]);

  const handleFolwData = (id: string) => {
    flowData(id).then((res: any) => {
      if (res?.data?.status) {
        setSetFolwData(res?.data);
        showToast("success", "Flow Data found");
      } else {
        setSetFolwData([]);
        showToast("error", "Flow Data not found");
      }
    });
  };

  // Table Columns
  // The "flow" button is its own role action (PAN_APPLICATIONS >
  // VIEW_APPLICATION_FLOW), the same one get-status-history is authorised
  // against; SUPER_ADMIN always passes.
  const canViewApplicationFlow = Boolean(
    AuthHOC({
      resultType: "BOOLEAN",
      type: "ACTION",
      moduleName: "PAN_APPLICATIONS",
      action: AccessAction.VIEW_APPLICATION_FLOW,
    })
  );

  const columns: columnTypes[] = [
    {
      hidden: !AuthHOC({
        resultType: "BOOLEAN",
        forApplicationStatus: true,
        applicationName: "PAN",
        applicationStatus: "IN_PROGRESS",
      }),
      noAuthRequired: true,
      field: "",
      headerName: "Move To",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <div>
            {row.status === "REJECT" ? (
              <button
                className="bg-green-400 text-white rounded px-2 py-1 font-medium"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  showConfirmationDialog({
                    title: "Heads Up",
                    text: "Are you sure want to move Application to In Progress?",
                    icon: "question",
                    showCancelButton: true,
                    next: (result: any) => {
                      if (result.isConfirmed) {
                        const formData = new FormData();
                        formData.append("requestedStatus", "IN_PROGRESS");
                        changeStatus({ body: formData, id: row._id }).then(
                          (res: any) => {
                            if (res.error) {
                              showToast("error", res.error.data?.message);
                            } else {
                              if (res.data?.status) {
                                showToast("success", res.data?.message);
                                navigate(`/pan/${row._id}`);
                              } else {
                                showToast("error", res.data?.message);
                              }
                            }
                          }
                        );
                      }
                    },
                  });
                }}
              >
                 In Progress
              </button>
            ) : (
              <div>-</div>
            )}
          </div>
        );
      },
    },
    {
      field: "createdDateToShow",
      headerName: "Date - Time",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => (
        <div className="py-2">
          <div className="text-slate-700 font-medium">
            {formatDateAndTime(row?.createdDateToShow, "DD MMM yyyy")}
          </div>
          <div className="text-[13px] font-medium text-slate-400">
            {formatDateAndTime(row?.createdDateToShow, "hh:mm A")}
          </div>
        </div>
      ),
    },
    // {
    //   field: "srn",
    //   headerName: "SRN",
    //   flex: "flex-[1.5_1.5_0%]",
    //   renderCell: (row: PANListResponse) => {
    //     return (
    //       <Tooltip title={row.srn}>
    //         <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden">
    //           {row.srn}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
  field: "srn",
  headerName: "SRN",
  flex: "flex-[1.5_1.5_0%]",
  renderCell: (row: PANListResponse) => {
    return (
      <div className="flex items-center gap-2 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        {row.srn && (
          <ATMCopyToClipboard
            tooltipTitle="Copy"
            copyText={row.srn}
          >
            <IoCopyOutline className="cursor-pointer text-[16px]" />
          </ATMCopyToClipboard>
        )}
        <Tooltip title={row.srn}>
          <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden">
            {row.srn || "-"}
          </span>
        </Tooltip>
        
      </div>
    );
  },
},
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => (
        <Tooltip title={row.name}>
          <span className="text-ellipsis overflow-hidden"> {row.name} </span>
        </Tooltip>
      ),
    },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   flex: "flex-[1.5_1.5_0%]",
    //   renderCell: (row: PANListResponse) => {
    //     return (
    //       <Tooltip title={row.email}>
    //         <span className="text-ellipsis overflow-hidden"> {row.email} </span>
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   field: "mobileNumber",
    //   headerName: "Mobile",
    //   flex: "flex-[1_1_0%]",
    // },
    {
  field: "mobileNumber",
  headerName: "Mobile",
  flex: "flex-[1_1_0%]",
  renderCell: (row: PANListResponse) => {
    return (
      <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
         {row.mobileNumber && (
          <ATMCopyToClipboard
            tooltipTitle="Copy"
            copyText={row.mobileNumber}
          >
            <IoCopyOutline className="cursor-pointer text-[16px]" />
          </ATMCopyToClipboard>
        )}
        <span>{row.mobileNumber || "-"}</span>

       
      </div>
    );
  },
},
    // {
    //   noAuthRequired: true,
    //   field: "distributorCode",
    //   headerName: "SJBT  Code",
    //   flex: "flex-[1.2_1.2_0%]",
    //   renderCell: (row: PANListResponse) => {
    //     return <span> {row.distributorCode || "N/A"} </span>;
    //   },
    // },
    {
  noAuthRequired: true,
  field: "distributorCode",
  headerName: "SJBT Code",
  flex: "flex-[1.2_1.2_0%]",
  renderCell: (row: PANListResponse) => {
    return (
      <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
         {row.distributorCode && (
          <ATMCopyToClipboard
            tooltipTitle="Copy"
            copyText={row.distributorCode}
          >
            <IoCopyOutline className="cursor-pointer text-[16px]" />
          </ATMCopyToClipboard>
        )}
        <span>{row.distributorCode || "N/A"}</span>

       
      </div>
    );
  },
},
    {
      field: "appliedByNumber",
      headerName: "Applied By (Mob. No.)",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return <span> {row.appliedByNumber || "N/A"} </span>;
      },
    },
    {
      field: "acknowledgementNumber",
      headerName: "Acknowledgement Number",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: PANListResponse) => {
        return (
         <div onClick={(e) => e.stopPropagation()}>
           {row.acknowledgementNumber && (
            <ATMCopyToClipboard
              tooltipTitle="Copy"
              copyText={row.acknowledgementNumber}
            >
              <IoCopyOutline className="cursor-pointer text-[16px]" />
            </ATMCopyToClipboard>
          )}
          <Tooltip title={row.acknowledgementNumber}>
            <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden">
              {row.acknowledgementNumber || "-"}
            </span>
          </Tooltip>
         </div>
        );
      },
    },
    {
      field: "applicationIndividualPrice",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <Tooltip title={row?.applicationIndividualPrice}>
            <span className="text-green-500 text-[13px] text-ellipsis overflow-hidden font-semibold">
              &#8377; {row?.applicationIndividualPrice || "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "verifiedByName",
      headerName: "Verified By",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <Tooltip title={row?.verifiedByName}>
            <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden font-semibold">
              {row?.verifiedByName || "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      /*
        Who filled the PAN form. "Done By" next to it names whoever moved the
        application to DONE — a separate, later step, so the two routinely name
        different operators.
      */
      field: "formFilledByName",
      headerName: "Submit By",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <Tooltip title={row?.formFilledByName}>
            <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden font-semibold">
              {row?.formFilledByName || "-"}
            </span>
          </Tooltip>
        );
      },
    },
     {
      field: "completedByName",
      headerName: "Done By",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <Tooltip title={row?.completedByName}>
            <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden font-semibold">
              {row?.completedByName || "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "rejectedByName",
      headerName: "Rejected By",
      flex: "flex-[1_1_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <Tooltip title={row?.rejectedByName}>
            <span className="text-primary-main text-[13px] text-ellipsis overflow-hidden font-semibold">
              {row?.rejectedByName || "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: PANListResponse) => {
        return (
         
            <div className="flex flex-col gap-2 py-2">
              <span
                className={`font-medium rounded-full flex gap-2 items-center bg-slate-100 px-2 py-1 text-[13px]  ${
                  applicationStatus?.[row.status]?.className
                }`}
              >
                <BsCircleFill className="text-[10px]" />
                {applicationStatus[row.status]?.label || "N/A"}{" "}
              </span>
            {/*
              The two form-fill statuses used to be excluded here, on the
              assumption that no acknowledgement exists yet at that point. It
              does: login (and the acknowledgement number with it) happens on
              the way OUT of IN_PROGRESS, so an application sitting on
              FORM_FILL_PENDING has already been logged in and can need its
              receipt replaced like any other. Excluding them also put this
              screen out of step with the History listing, which offers the
              button at those statuses.
            */}
            {canReuploadAcknowledgement &&
              !["REJECT", "PENDING", "CANCELLED", "IN_PROGRESS"].includes(
                row?.status
              ) && (
                <ATMLoadingButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setPanIdVerfiy(row._id || "");
                    setIsOpenReuploadDialog(true);
                  }}
                  className="py-0 rounded-full text-sky-600  bg-white hover:bg-sky-600 hover:text-white transition-all"
                >
                  <div className="text-[12px] py-1 ">
                    Reupload Acknowledgement
                  </div>
                </ATMLoadingButton>
              )}
            </div>
        );
      },
    },
    {
      field: "application_flow",
      // Gated by the action above, not by the role's field list.
      noAuthRequired: true,
      hidden: !canViewApplicationFlow,
      headerName: "Application Flow",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: PANListResponse) => {
        return (
          <div className="flex flex-col gap-2 py-2">
            <ATMLoadingButton    
              onClick={(e) => {
                e.stopPropagation();
                setIsShowFlowDialog(true);
                handleFolwData(row?._id);
              }}
              isLoading={
                flowDataInfo?.originalArgs === row?._id
                  ? flowDataInfo?.isLoading
                  : false
              }
              loadingText="flow"
            >
              flow
            </ATMLoadingButton>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <TabSearchHistoryApplicationPANListing
        columns={columns}
        isLoading={isFetching || isLoading}
        row={data?.data}
        searchValue={panSearchHistoryValue}
      />
        {isOpenReuploadDialog && (
        <ReuploadAcknowledgementDialogWrapper
          serviceName="PAN"
          data={data?.data}
          onClose={() => setIsOpenReuploadDialog(false)}
          onSubmit={(formData, onComplete) => {
            reuploadAcknowledgment({
              id: PanIdVerfiy || "",
              body: formData,
            }).then((res: any) => {
              onComplete();
              if (res?.error) {
                showToast("error", res?.error?.data?.message);
              } else {
                if (res?.data?.status) {
                  showToast("success", res?.data?.message);
                  setIsOpenReuploadDialog(false);
                } else {
                  showToast("error", res?.data?.message);
                }
              }
            });
          }}
        />
      )}
      {isShowFlowDialog && !flowDataInfo?.isLoading &&
        <HistoryDialog
          data={setFlowData}
          onClose={() => {
            setIsShowFlowDialog(false);
          }}
        />
      }
    </>
  );
};

export default TabSearchHistoryApplicationPANListingWrapper;
